import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ub ub-ver fw" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("暂无数据")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flow_item = _resolveComponent("flow-item")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dataSource?.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dataSource, (item, index) => {
          return (_openBlock(), _createBlock(_component_flow_item, {
            isFirst: index == 0,
            isBottom: index == _ctx.dataSource?.length - 1,
            key: index,
            item: item
          }, null, 8, ["isFirst", "isBottom", "item"]))
        }), 128))
      : (_openBlock(), _createBlock(_component_a_empty, {
          key: 1,
          image: _ctx.simpleImage
        }, {
          description: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["image"]))
  ]))
}